import gql from 'graphql-tag';

/**
 * Lightweight run fragment for line plot delta queries.
 *
 * This intentionally omits fields from RunWithoutRunInfoStateBasicFragment
 * that the line plot never reads but that trigger expensive backend resolvers:
 *   - readOnly  (2 MySQL queries/run — FetchProjectByID + FetchEntityByID)
 *   - computeSeconds (1 MySQL query/run — CountComputeHoursByRun)
 *   - github (1 MySQL query/run — FetchJobByID)
 *   - agent, framework, logLineCount, notes, shouldStop
 */
export const LINE_PLOT_RUN_FRAGMENT = gql`
  fragment LinePlotRunFragment on Run {
    commit
    createdAt
    heartbeatAt
    defaultColorIndex
    displayName
    group
    groupCounts
    host
    jobType
    project {
      id
      entityName
      name
    }
    projectId
    state
    stopped
    sweep {
      id
      name
      displayName
      config
    }
    user {
      id
      username
      photoUrl
    }
  }
`;
